export const xinB = [
  [
    [113.67598248285914, 23.016548488269184, 10],
    [113.67599536211831, 23.01656205382163, 10],
  ],
  [
    [113.67605575886226, 23.0164888800864, 10],
    [113.67606863814513, 23.016502445615096, 10],
  ],
  [
    [113.67612903481204, 23.01642927176984, 10],
    [113.67614191409662, 23.016442837292683, 10],
  ],
  [
    [113.67620231059989, 23.016369663418704, 10],
    [113.6762151898862, 23.01638322893569, 10],
  ],
  [
    [113.67627558642091, 23.016310055033085, 10],
    [113.67628846570891, 23.016323620544213, 10],
  ],
  [
    [113.67634886217756, 23.016250446612926, 10],
    [113.67636174146726, 23.016264012118203, 10],
  ],
  [
    [113.67642213786984, 23.016190838158224, 10],
    [113.67643501716124, 23.016204403657653, 10],
  ],
  [
    [113.67649541349772, 23.016131229669014, 10],
    [113.67650829279083, 23.01614479516258, 10],
  ],
  [
    [113.67656868906123, 23.01607162114526, 10],
    [113.67658156835604, 23.016085186632974, 10],
  ],
  [
    [113.67664196456036, 23.016012012586977, 10],
    [113.67665484385687, 23.01602557806883, 10],
  ],
  [
    [113.67671523999512, 23.015952403994167, 10],
    [113.67672811929333, 23.01596596947017, 10],
  ],
  [
    [113.67678851536549, 23.01589279536682, 10],
    [113.67680139466542, 23.015906360836972, 10],
  ],
  [
    [113.6768617906825, 23.015833186695996, 10],
    [113.67687466996213, 23.015846752178188, 10],
  ],
  [
    [113.67693506592411, 23.015773577999585, 10],
    [113.67694794520547, 23.015787143475926, 10],
  ],
  [
    [113.67700834110137, 23.015713969268646, 10],
    [113.6770212203844, 23.01572753473913, 10],
  ],
  [
    [113.67708161621424, 23.01565436050318, 10],
    [113.67709449549898, 23.01566792596781, 10],
  ],
  [
    [113.67715489116519, 23.01559475170314, 10],
    [113.67716777045162, 23.01560831716192, 10],
  ],
  [
    [113.67722816614929, 23.015535142868618, 10],
    [113.67724104543746, 23.015548708321543, 10],
  ],
  [
    [113.67730144106905, 23.015475533999563, 10],
    [113.67731432035889, 23.015489099446636, 10],
  ],
  [
    [113.6773747159244, 23.015415925095986, 10],
    [113.67738759521596, 23.015429490537205, 10],
  ],
  [
    [113.6774479907154, 23.015356316157877, 10],
    [113.67746087000864, 23.015369881593237, 10],
  ],
  [
    [113.67752126544201, 23.015296707185243, 10],
    [113.67753414473698, 23.015310272614748, 10],
  ],
  [
    [113.67759454010424, 23.01523709817808, 10],
    [113.67760741940091, 23.015250663601726, 10],
  ],
  [
    [113.6776678147021, 23.015177489136384, 10],
    [113.67768069400049, 23.015191054554176, 10],
  ],
  [
    [113.6777410892356, 23.015117880060167, 10],
    [113.67775396853567, 23.015131445472107, 10],
  ],
  [
    [113.67781436369367, 23.01505827104867, 10],
    [113.67782724301745, 23.015071836436853, 10],
  ],
  [
    [113.6778876380984, 23.0149986619034, 10],
    [113.67790051742388, 23.01501222728573, 10],
  ],
  [
    [113.67796091243876, 23.0149390527236, 10],
    [113.67797379176595, 23.014952618100075, 10],
  ],
  [
    [113.67803418671474, 23.01487944350928, 10],
    [113.67804706604363, 23.0148930088799, 10],
  ],
  [
    [113.67810746082883, 23.014819834260386, 10],
    [113.67812034015941, 23.014833399625147, 10],
  ],
  [
    [113.67818073497605, 23.01476022497701, 10],
    [113.67819361430834, 23.014773790335926, 10],
  ],
  [
    [113.67825400905893, 23.014700615659116, 10],
    [113.67826688839291, 23.014714181012177, 10],
  ],
  [
    [113.67832728307742, 23.014641006306697, 10],
    [113.67834016241312, 23.01465457165389, 10],
  ],
  [
    [113.67840055703154, 23.01458139691975, 10],
    [113.67841343636894, 23.014594962261096, 10],
  ],
  [
    [113.67847383092128, 23.014521787498275, 10],
    [113.6784867102604, 23.014535352833768, 10],
  ],
  [
    [113.67854710474666, 23.014462178042283, 10],
    [113.67855998408747, 23.014475743371918, 10],
  ],
  [
    [113.67862037850766, 23.01440256855176, 10],
    [113.67863325785017, 23.01441613387554, 10],
  ],
  [
    [113.67869365221529, 23.014342959017775, 10],
    [113.6787065315375, 23.014356524353598, 10],
  ],
  [
    [113.67876692584754, 23.014283349458204, 10],
    [113.67877980517146, 23.01429691478818, 10],
  ],
  [
    [113.67884019941542, 23.014223739864114, 10],
    [113.67885307874106, 23.014237305188235, 10],
  ],
  [
    [113.67891347291895, 23.014164130235518, 10],
    [113.67892635224626, 23.01417769555378, 10],
  ],
  [
    [113.6789867324955, 23.014104521985026, 10],
    [113.67899962882498, 23.01411807345097, 10],
  ],
  [
    [113.67905987906371, 23.01404480930144, 10],
    [113.67907280788717, 23.014058334206933, 10],
  ],
  [
    [113.67913288207656, 23.013984946393766, 10],
    [113.67914584334699, 23.013998444658124, 10],
  ],
  [
    [113.67920574106687, 23.01392493333529, 10],
    [113.679218734696, 23.01393840491175, 10],
  ],
  [
    [113.67927845580901, 23.01386477051229, 10],
    [113.67929148176908, 23.013878215304157, 10],
  ],
  [
    [113.67935102584528, 23.013804458260942, 10],
    [113.679364084048, 23.01381787622153, 10],
  ],
  [
    [113.67942345078524, 23.013743996852043, 10],
    [113.67943654114245, 23.013757387934895, 10],
  ],
  [
    [113.67949573040347, 23.013683386581828, 10],
    [113.67950885288724, 23.01369675069, 10],
  ],
  [
    [113.67956786423247, 23.013622627704116, 10],
    [113.67958101877403, 23.013635964774803, 10],
  ],
  [
    [113.67963985197838, 23.013561720671223, 10],
    [113.6796530385108, 23.013575030640087, 10],
  ],
  [
    [113.67971169325266, 23.013500665571964, 10],
    [113.67972491170555, 23.01351394837768, 10],
  ],
  [
    [113.67978338776074, 23.01343946276906, 10],
    [113.67979663806713, 23.01345271834738, 10],
  ],
  [
    [113.67985493501538, 23.013378112713266, 10],
    [113.6798682171067, 23.01339134100137, 10],
  ],
  [
    [113.67992633481092, 23.013316615594313, 10],
    [113.6799396486395, 23.01332981651133, 10],
  ],
  [
    [113.67999758667962, 23.01325497166564, 10],
    [113.6800109321574, 23.013268145165572, 10],
  ],
  [
    [113.68006869040667, 23.013193181305446, 10],
    [113.6800820674846, 23.013206327308517, 10],
  ],
  [
    [113.68013964551331, 23.013131244776684, 10],
    [113.68015305412408, 23.01314436321895, 10],
  ],
  [
    [113.68021045161947, 23.013069162431474, 10],
    [113.68022389167504, 23.013082253267182, 10],
  ],
  [
    [113.68028110851036, 23.013006934557943, 10],
    [113.68029457996177, 23.01301999770711, 10],
  ],
  [
    [113.68035161579509, 23.012944561517827, 10],
    [113.68036511859431, 23.012957596899415, 10],
  ],
];
